export class SnapshotFindingCountsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detectors",
            "baseName": "detectors",
            "type": "Array<DetectorSummary>",
            "format": ""
        },
        {
            "name": "snapshotCount",
            "baseName": "snapshotCount",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotFindingCountsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
